import { DispatcherEvent } from '@carvana/merch-native';
import { useCallback } from 'react';
import OrderState from '~/constants/common/OrderState';
import { useIsLoggedIn } from '~/context/common/UserContext';
import {
  useClosedAccountModal,
  useOpenAccountModal
} from '~/hooks/common/accountModal/useAccountModal';
import { useGetRcbUserPurchasingGetter } from '~/hooks/vdp/services/useGetUserPurchasing';
import { type PurchaseEventPayload } from '~/native/common/contracts';

export default function useLogInAndShowPreOrder(
  eventPayload: PurchaseEventPayload
) {
  const closedAccountModal = useClosedAccountModal();
  const getUserPurchasing = useGetRcbUserPurchasingGetter();
  const isLoggedIn = useIsLoggedIn();
  const openAccountModal = useOpenAccountModal();

  return useCallback(
    (confirmContinue: () => void, onContinue: () => void) => () => {
      if (isLoggedIn) return onContinue();

      openAccountModal({
        nativeOptions: {
          eventDispatch: DispatcherEvent.StartPreOrder,
          eventPayload
        },
        onSuccess: async () => {
          const purchaseResult = await getUserPurchasing();

          closedAccountModal('submit');

          if (purchaseResult.orderState === OrderState.Reserved) {
            confirmContinue();
          } else {
            onContinue();
          }
        }
      });
    },
    [
      closedAccountModal,
      eventPayload,
      getUserPurchasing,
      isLoggedIn,
      openAccountModal
    ]
  );
}
